import { render, staticRenderFns } from "./CaptureDetail.vue?vue&type=template&id=33cbd620&"
import script from "./CaptureDetail.vue?vue&type=script&lang=js&"
export * from "./CaptureDetail.vue?vue&type=script&lang=js&"
import style0 from "./CaptureDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports